import React from 'react';
import { AuthContext } from 'context/AuthContext';
import { hasAllRequiredPermissions, hasAnyRequiredPermission } from 'auth/Permissions';
import FourOhFourPage from 'screens/404Page';

interface RequiresPermissionsProps {
    permissions: string[];
    isAllPermissionsRequired?: boolean;
}

const RequiresPermissions: React.FC<React.PropsWithChildren<RequiresPermissionsProps>> = ({
	permissions,
	isAllPermissionsRequired = false,
	children,
}) => {
	const { currentUser } = React.useContext(AuthContext);

	const hasPermissions = isAllPermissionsRequired
		? hasAllRequiredPermissions(currentUser.permissions, permissions)
		: hasAnyRequiredPermission(currentUser.permissions, permissions);

	return hasPermissions ? <React.Fragment>{children}</React.Fragment> : <FourOhFourPage />;
};

export default RequiresPermissions;